import { AfterContentInit, AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import { FuncaoFacade } from "../../funcao.facade";
import { Funcao } from "../../models/funcao";
import {BrowserSupport, FileType} from "../../../shared/util/browser-support";
import {HttpEventType, HttpResponse} from "@angular/common/http";

@Component({
  selector: "app-funcao-modelos-modal",
  templateUrl: "./funcao-modelos-modal.component.html",
  styleUrls: ["./funcao-modelos-modal.component.scss"],
})
export class FuncaoModelosModalComponent implements OnInit, OnDestroy, AfterViewInit {

  public loading$: Observable<boolean> = new Observable<boolean>();

  public funcaoSelecionada$: Observable<Funcao> = new Observable<Funcao>(null);
  public funcoesAdicionadas$: Observable<Funcao[]>;

  constructor(
    private funcaoFacade: FuncaoFacade,
    public dialogRef: MatDialogRef<FuncaoModelosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.funcaoSelecionada$ = this.funcaoFacade.getFuncaoSelecionada$();
    this.funcoesAdicionadas$ = this.funcaoFacade.getFuncoesAdicionadas$();
  }

  ngOnInit(): void {
    this.funcaoFacade.reset();

    this.funcaoFacade.buscarCategorias();
    this.funcaoFacade.buscarFuncoes('');
  }

  ngAfterViewInit() {
    this.loading$ = this.funcaoFacade.getLoading$();
  }

  ngOnDestroy(): void {
    this.funcaoFacade.destroy();
  }

  adicionarFuncaoSelecionada() {
    this.funcaoFacade.addFuncaoAdicionada();
  }

  removerFuncaoAdicionada($event: Funcao): void {
    this.funcaoFacade.removeFuncaoAdicionada($event);
  }

  baixarModelosFuncoesAdicionadas() {
    this.funcaoFacade.baixarModelosFuncoesAdicionadas()
      .pipe()
      .subscribe(respData => {
        if (respData.type === HttpEventType.DownloadProgress) {
          console.log("esta baixando o arquivo");
        }
        if (respData.type instanceof HttpResponse || respData instanceof ArrayBuffer) {
          this.downloadFile(respData);
          this.dialogRef.close();
        }
      }, error => {
        console.log(error);
      }
    );
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'application/zip' });
    BrowserSupport.saveAs(blob, 'Enquadramento_modelos_para_inclusao_regra_simples.zip');
  }
}
